import { Injectable } from "@angular/core";
import {AddMultipleSecuritiesDialogComponent} from '@irb/irb-models/add-multiple-securities-dialog/add-multiple-securities-dialog.component';
import { SecurityMasterGridLayoutService } from '@irb/irb-models/security-master/security-master.grid-layout.service';
import {AppService} from "@irb/app.service";
import { SecurityMasterAssetCategoryService } from '@irb/irb-models/security-master/security-master.asset-category.service';
import { DropdownSearchMultipleRendererComponent } from '@irb-common/components/grid/renderers/dropdown-search-multiple.cell.component';
import { DropdownFilterRendererComponent } from "@irb-common/components/grid/renderers/dropdown-filter.cell.component";
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { MorningstarService } from '@irb/irb-models/security-master/morningstar.service';
import { SacSecurityTypeService } from "../security-master/sac-security-type.service";
@Injectable({
    providedIn: "root"
})
export class AddMultipleSecuritiesGridService implements GridLayoutService<AddMultipleSecuritiesDialogComponent> {

    constructor(private smgls: SecurityMasterGridLayoutService, private as: AppService, private smac: SecurityMasterAssetCategoryService, private mss: MorningstarService,
                private ssts: SacSecurityTypeService) {}

    getFrameworkComponents() {
        return {
            DropdownFilterRendererComponent: DropdownFilterRendererComponent,
            DropdownSearchMultipleRendererComponent: DropdownSearchMultipleRendererComponent
        };
    }

    getColumnDefs(parent: AddMultipleSecuritiesDialogComponent) {
        let columns: any = [
            {
                headerName: 'Select All',
                colId: 'selectAll',
                headerComponent: 'customHeader',
                cellRenderer: 'customHeader',
                cellRendererParams: {parentObject: parent, type: 'rowCheckBox'},
                suppressColumnsToolPanel: true,
                suppressFiltersToolPanel: true,
                suppressSizeToFit: true,
                toolPanelClass: 'toolpanel-header-checkbox-hide',
                headerComponentParams: {parentObject: parent, type: 'headerCheckBox'},
                floatingFilterComponent: 'customHeader',
                floatingFilterComponentParams: {parentObject: parent, type: 'clearAllBtn'},
                suppressFloatingFilterButton: true,
                pinned: 'left',
                suppressMovable: true,
                lockPosition: true,
                lockVisible: true,
                sortable: false,
                filter: true,
                resizable: true,
                minWidth: 25,
                width: 25,
                maxWidth:25,
                cellStyle: {'padding': '5px 3px 0 2px'},
                headerClass: 'customHeaderClassSelectAll',
                cellClass: 'selectAllCheckBoxRecord'
            },

            {
                headerName: 'Security',
                children: [
                    {
                        headerName: 'Symbol',
                        colId: 'securitySymbol',
                        field: 'securitySymbol',
                        sort: 'asc',
                        lockPosition: true,
                        lockVisible: true,
                        pinned: 'left',
                        minWidth: 106,
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            buttons: ['reset', 'apply'],
                            values: (params: any) => {
                                params.success(parent.securitySymbolList);
                            },
                            newRowsAction: 'keep',
                            suppressSorting: true,
                            cellHeight: 30,
                            closeOnApply: true                            
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {
                            columnToolTipInfo: this.smgls.cashSecurity(),
                        }
                    },
                    {
                        headerName: 'Description',
                        colId: 'securityDescription',
                        field: 'securityDescription',
                        minWidth: 218,
                        filter: 'agTextColumnFilter',
                        suppressFloatingFilterButton: true,
                        cellRenderer: 'cellRendererFormatter'
                    },
                    {
                        headerName: parent.ENABLE_AS_SECTYPE ? 'Trade Type' : 'Type',
                        colId: 'securityType',
                        field: 'securityType',
                        cellRenderer: this.formatSecurityType,
                        minWidth: 75,
                        filter: (parent?.eventData?.type === 'editCashEquivalents') ? '': 'agSetColumnFilter',
                        filterParams: {
                            buttons: ['reset', 'apply'],
                            values: (params: any) => {
                                params.success(parent.securityTypeList);
                            },
                            newRowsAction: 'keep',
                            suppressSorting: true,
                            cellHeight: 30,
                            closeOnApply: true                            
                        }
                    },
                    {
                        headerName: 'In # Sec Models',
                        colId: 'securityModels',
                        field: 'securityModels',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: ' '},
                        minWidth: 80,
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            buttons: ['reset', 'apply'],
                            values: (params: any) => {
                                params.success(parent.securityModels);
                            },
                            newRowsAction: 'keep',
                            suppressSorting: true,
                            cellHeight: 30,
                            closeOnApply: true                            
                        }
                    },
                    {
                        headerName: 'CustCat',
                        colId: 'customCategoryName',
                        headerComponentParams: {
                            irbColInfo: this.smgls.customCategoryColInfo()
                        },
                        field: 'customCategoryName',
                        minWidth: 160,
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            buttons: ['reset', 'apply'],
                            values: (params: any) => {
                                params.success(parent.customCategoryList);
                            },
                            newRowsAction: 'keep',
                            suppressSorting: true,
                            cellHeight: 30,
                            closeOnApply: true                            
                        },
                        cellRenderer: 'cellRendererFormatter'
                    },
                    {
                        headerName: 'NER',
                        colId: 'netExpenseRatio',
                        headerComponentParams: {
                            irbColInfo: this.smgls.nerColInfo()
                        },
                        field: 'netExpenseRatio',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: '%', decimalPosition: '2'},
                        minWidth: 70,
                        hide: this.getDefaultHiddenState(parent, 'netExpenseRatio', true)
                    }]
            }];

                columns.push({
                    headerName: 'Schwab Asset Classes',
                    children: [
                        {
                            headerName: "Level 1",
                            field: "acLevel1",
                            minWidth: 160,
                            flex: 1,
                            suppressFiltersToolPanel: true,
                            sortable: false,
                            floatingFilterComponent: 'irbInputFloatingFilterComponent',
                            filter: 'irbAgSearchMultipleColumnFilterComponent',
                            filterParams: (_params: any) => {
                                return {
                                    values: this.smac.getDropdownOptionsForAssetClasses(this.smac.assetClassesLevel1),
                                    enableHiddenSearchResults: false,
                                    enableEmptySearchTerm: true
                                }
                            },    
                            cellClass: 'dropdownSearchMultipleCell',
                            cellRenderer: 'DropdownSearchMultipleRendererComponent',
                            cellRendererParams: (params: any) => {
                                return {
                                    defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel1),
                                    noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                                    cellStyle: "classes",
                                    canEdit: false,
                                    hiddenLabelPanelTitle: "Schwab Asset Classes - Level 1",
                                    hiddenLabelDescription: "classes"
                                };
                            }
                        },
                        {
                            headerName: "Level 2",
                            field: "acLevel2",
                            minWidth: 160,
                            flex: 1,
                            suppressFiltersToolPanel: true,
                            sortable: false,
                            floatingFilterComponent: 'irbInputFloatingFilterComponent',
                            filter: 'irbAgSearchMultipleColumnFilterComponent',
                            filterParams: (_params: any) => {
                                return {
                                    values: this.smac.getDropdownOptionsForAssetClasses(this.smac.assetClassesLevel2),
                                    enableHiddenSearchResults: false,
                                    enableEmptySearchTerm: true
                                }
                            },    
                            cellClass: 'dropdownSearchMultipleCell',
                            cellRenderer: 'DropdownSearchMultipleRendererComponent',
                            cellRendererParams: (params: any) => {
                                return {
                                    defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel2),
                                    noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                                    cellStyle: "classes",
                                    canEdit: false,
                                    hiddenLabelPanelTitle: "Schwab Asset Classes - Level 2",
                                    hiddenLabelDescription: "classes"
                                };
                            },
                            hide: this.getDefaultHiddenState(parent, 'acLevel2', true)
                        },
                        {
                            headerName: "Level 3",
                            field: "acLevel3",
                            minWidth: 160,
                            flex: 1,
                            suppressFiltersToolPanel: true,
                            sortable: false,
                            floatingFilterComponent: 'irbInputFloatingFilterComponent',
                            filter: 'irbAgSearchMultipleColumnFilterComponent',
                            filterParams: (_params: any) => {
                                return {
                                    values: this.smac.getDropdownOptionsForAssetClasses(this.smac.assetClassesLevel3),
                                    enableHiddenSearchResults: false,
                                    enableEmptySearchTerm: true
                                }
                            },    
                            cellClass: 'dropdownSearchMultipleCell',
                            cellRenderer: 'DropdownSearchMultipleRendererComponent',
                            cellRendererParams: (params: any) => {
                                return {
                                    defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel3),
                                    noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                                    cellStyle: "classes",
                                    canEdit: false,
                                    hiddenLabelPanelTitle: "Schwab Asset Classes - Level 3",
                                    hiddenLabelDescription: "classes"
                                };
                            },
                            hide: this.getDefaultHiddenState(parent, 'acLevel3', true)
                        },
                        {
                            headerName: "Level 4",
                            field: "acLevel4",
                            minWidth: 160,
                            flex: 1,
                            suppressFiltersToolPanel: true,
                            sortable: false,
                            floatingFilterComponent: 'irbInputFloatingFilterComponent',
                            filter: 'irbAgSearchMultipleColumnFilterComponent',
                            filterParams: (_params: any) => {
                                return {
                                    values: this.smac.getDropdownOptionsForAssetClasses(this.smac.assetClassesLevel4),
                                    enableHiddenSearchResults: false,
                                    enableEmptySearchTerm: true
                                }
                            },    
                            cellClass: 'dropdownSearchMultipleCell',
                            cellRenderer: 'DropdownSearchMultipleRendererComponent',
                            cellRendererParams: (params: any) => {
                                return {
                                    defaultValue: this.smac.getCellDisplayForAssetClasses(params.data.acLevel4),
                                    noneDisplayText: params.data?.securitySymbol === '$CASH' ? 'Cash' : 'none',
                                    cellStyle: "classes",
                                    canEdit: false,
                                    hiddenLabelPanelTitle: "Schwab Asset Classes - Level 4",
                                    hiddenLabelDescription: "classes"
                                };
                            },
                            hide: this.getDefaultHiddenState(parent, 'acLevel4', true)
                        }
                    ]
                });

            columns.push({
                headerName: 'Trading Rules',
                children: [{
                    headerName: 'Min Buy $',
                    colId: 'buyMinimum',
                    field: 'buyMinimum',
                    cellRenderer: 'cellRendererFormatter',
                    cellRendererParams: {type: 'currency', isCashSecuritySymbol: true},
                    hide : true,
                    minWidth: 85
                },
                    {
                        headerName: 'Min Sell $',
                        colId: 'sellMinimum',
                        field: 'sellMinimum',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', isCashSecuritySymbol: true},
                        hide : true,
                        minWidth: 85
                    },
                    {
                        headerName: 'Min Buy %',
                        colId: 'buyMinimumPercent',
                        field: 'buyMinimumPercent',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: '%', isCashSecuritySymbol: true},
                        hide : true,
                        minWidth: 85,
                    },
                    {
                        headerName: 'Min Sell %',
                        colId: 'sellMinimumPercent',
                        field: 'sellMinimumPercent',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {
                            type: 'currency',
                            displaySymbol: '%',
                            isCashSecuritySymbol: true,
                            decimalPosition: '2'
                        },
                        hide : true,
                        minWidth: 85
                    }]
            },
            {
                headerName: 'Restrictions',
                children: [
                    {
                        headerName: 'Type',
                        colId: 'sellingTreatment',
                        field: 'sellingTreatment',
                        minWidth: 150,
                        hide : true,
                        cellRenderer: this.formatRestriction
                    },
                    {
                        headerName: 'Action to Take',
                        colId: 'conditions',
                        field: 'conditions',
                        minWidth: 120,
                        sortable: false,
                        hide : true,
                        cellRenderer: this.formatRestrictionCondition
                    }]
            },
            {
                headerName: 'Equivalents & Alternatives',
                children: [
                    {
                        headerName: 'Eqvs',
                        colId: 'equivalenceQty',
                        headerComponentParams: {
                            irbColInfo: this.smgls.eqvsColInfo()
                        },
                        field: 'equivalenceQty',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: ' '},
                        hide : true,
                        minWidth: 75
                    },
                    {
                        headerName: 'Alt if Held',
                        colId: 'altIfHeldSymbol',
                        headerComponentParams: {
                            irbColInfo: this.smgls.altIfHeldColInfo()
                        },
                        field: 'altIfHeldSymbol',
                        hide : true,
                        minWidth: 85
                    },
                    {
                        headerName: 'Min Alt',
                        colId: 'tradeMinimumAlternativeSymb',
                        field: 'tradeMinimumAlternativeSymb',
                        hide : true,
                        minWidth: 108
                    },
                    {
                        headerName: 'Alt Sec',
                        colId: 'taxQualAltSecSymb',
                        headerComponentParams: {
                            irbColInfo: this.smgls.altSecurityColInfo()
                        },
                        field: 'taxQualAltSecSymb',
                        hide : true,
                        minWidth: 125
                    },
                    {
                        headerName: 'Alt Acct',
                        colId: 'invrsAccountType',
                        headerComponentParams: {
                            irbColInfo: this.smgls.altAccountColInfo()
                        },
                        field: 'invrsAccountType',
                        hide : true,
                        minWidth: 75
                    },
                    {
                        headerName: 'Tax Loss Harvest',
                        colId:'isTlhEnabled',
                        field: 'isTlhEnabled',
                        minWidth:85,
                        valueGetter: (params: any) => {
                            let returnValue = '';
                            if (params.data) {
                                switch (params.data.isTlhEnabled) {
                                    case true:
                                        returnValue = 'On';
                                        break;
                                    case false:
                                        returnValue = 'Off'
                                        break;
                                    default:
                                        returnValue = ''
                                }
                            }
                            returnValue = !parent.isTLHSetInGlobal ? '' : returnValue;
                            return returnValue;
                        },
                       filter: 'agSetColumnFilter',
                       filterParams: {
                           values: (params: any) => {
                               params.success(['On','Off']);
                           },
                           buttons: ['reset', 'apply'],
                           newRowsAction: 'keep',
                           suppressSorting: true,
                           cellHeight: 30,
                           closeOnApply: true
                       }
                    },
                    {
                        headerName: 'Wash sale alternate',
                        colId: 'tlhWashSaleSymbol',
                        field: 'tlhWashSaleSymbol',
                        minWidth: 100,
                        width: 100,
                        cellRenderer: 'cellRendererFormatter',
                        filter: 'agSetColumnFilter',
                         filterParams: {
                             buttons:['reset', 'apply'],
                             values: (params: any) => {
                                 params.success(parent.washSaleSymbolList);
                             },
                             newRowsAction: 'keep',
                             suppressSorting: true,
                             cellHeight: 30,
                             refreshValuesOnOpen: true,
                             closeOnApply: true
                         },
                    }]

            },
            {
                headerName: 'Household Location',
                children: [
                    {
                        headerName: 'Level',
                        colId: 'taxabilityBias',
                        headerComponentParams: {
                            irbColInfo: this.smgls.levelColInfo()
                        },
                        field: 'taxabilityBias',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: ' '},
                        hide : true,
                        minWidth: 70
                    },
                    {
                        headerName: 'Roth Level',
                        colId: 'rothLevel',
                        headerComponentParams: {
                            irbColInfo: this.smgls.rothColInfo()
                        },
                        field: 'rothLevel',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: ' '},
                        hide : true,
                        minWidth: 95
                    }]
            },
            {
                headerName: 'Redemption Penalties',
                children: [
                    {
                        headerName: 'Amount $',
                        colId: 'redemptionPenaltyDollarAmount',
                        field: 'redemptionPenaltyDollarAmount',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: '$'},
                        hide : true,
                        minWidth: 85
                    },
                    {
                        headerName: 'Days $',
                        colId: 'tdaRedemptionPenaltyDays',
                        field: 'tdaRedemptionPenaltyDays',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: ' '},
                        hide : true,
                        minWidth: 85
                    },
                    {
                        headerName: 'Amount %',
                        colId: 'redemptionPenaltyPercent',
                        field: 'redemptionPenaltyPercent',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: '%', decimalPosition: '2'},
                        hide : true,
                        minWidth: 85
                    },
                    {
                        headerName: 'Days %',
                        colId: 'redemptionPenaltyDays',
                        field: 'redemptionPenaltyDays',
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {type: 'currency', displaySymbol: ' '},
                        hide : true,
                        minWidth: 85
                    },

                ]
            },
            {
                headerName: 'External Holdings',
                children: [{
                    headerName: 'Share Price',
                    colId: 'externalSharePrice',
                    field: 'externalSharePrice',
                    cellRendererSelector: this.formatSharePrice,
                    hide : true,
                    minWidth: 120
                }]
            },
            {
                headerName: 'Options',
                children: [{
                    headerName: 'Options',
                    colId: 'hasOptions',
                    headerComponentParams: {
                        irbColInfo: this.smgls.optionColInfo()
                    },
                    field: 'hasOptions',
                    minWidth: 85,
                    hide : true,
                    cellRendererSelector: this.formatHasOptions,
                }]
            }
        );
        if (parent.ENABLE_AS_SECTYPE) {
            columns[1].children.splice(3, 0, {
                headerName: 'Security Type',
                colId: 'sacSecurityType',
                field: 'sacSecurityType',
                minWidth: 80,
                flex: 1,
                filter: 'irbAgSearchMultipleColumnFilterComponent',
                suppressFiltersToolPanel: true,
                floatingFilterComponent: 'irbInputFloatingFilterComponent',
                filterParams: (_params: any) => {
                    return {
                        values: this.ssts.getDropdownOptionsForSacSecurityTypes(),
                        enableHiddenSearchResults: false,
                        enableEmptySearchTerm: true
                    };
                }
            });

            columns[1].children.splice(7, 0, {
                headerName: "Morningstar Stock Style",
                field: 'styleBoxLabel',
                suppressFiltersToolPanel: true,
                floatingFilterComponent: 'irbInputFloatingFilterComponent',
                filter: 'irbAgSearchMultipleColumnFilterComponent',
                filterParams: (_params: any) => {
                    return {
                        values: this.mss.getDropdownOptionsForMorningstarStyles(),
                        enableHiddenSearchResults: false,
                        enableEmptySearchTerm: true
                    }
                },
                flex: 1
            });
        }

        if (!parent.isTlhWsaEnabled) {
            columns[4].children.splice(5, 2);
        }
        
        return columns;
    }



    formatRestriction(params: any) {
        switch (params.data.sellingTreatment) {
            case "NEVER_SELL":
                return "Never Sell";
            case "NO_RESTRICTION":
                return "No restriction";
            case "NEVER_BUY":
                return "Never Buy";
            case "NEVER_BUY_AND_SELL":
                return "Never Buy and Never Sell";
            case "UN_MANAGED":
                return "Exclude";
            default :
                return "";
        }
    }

    formatSecurityType(params: any) {

        switch (params.data.securityType) {

            case "EQUITY":
                return "Equity";
            case "EQ":
                return "Equity";
            case "MUTUAL_FUND":
                return "Mutual Fund";
            case "MF":
                return "Mutual Fund";
            case "CASH":
                return "Cash";
            case "GROUP":
                return "Group";
            case "BOND":
                return "Bond";
            case "OTHER":
                return "Other";
            case "EXTERNAL":
                return "External";
            case "CustCat":
                return "Category";
            case "OPTION":
                return "Option";
            default:
                return params.data.securityType;
        }
    }

    formatHasOptions(params: any) {
        if (params.data) {
            if (params.data.hasOptions === true) {
                return {
                    component: 'cellRendererFormatter',
                    params: {
                        value: 'View',
                        link: () => {
                            return false;
                        }
                    }
                }
            } else if (params.data.hasOptions === false) {
                return {
                    component: 'cellRendererFormatter',
                    params: {
                        value: 'n/a',
                    }
                }
            }
        }

    }

    formatRestrictionCondition(params: any) {

        if (params.data.sellingTreatment === 'NEVER_BUY' || params.data.sellingTreatment === 'NEVER_BUY_AND_SELL') {
            switch (params.data.conditions) {
                case "Leave in cash":
                    return "Leave in Cash";
                case "Buy an alternate security":
                    return params.data.altSecuritySymbol;
                case "Pro-rate across other model securities":
                    return "Pro-rate";
                default :
                    return "";
            }
        }
    }

    formatSharePrice(params:any) {
        if (params.data) {
            if (params.data.securitySymbol === '$CASH' || params.data.securityType !== 'EXTERNAL') {
                return {
                    component: 'cellRendererFormatter',
                    params:{'value':'n/a'}
                }
            } else if (params.data.securityType === 'EXTERNAL'){
                return {
                    component: 'cellRendererFormatter',
                    params:{'value':params.data.externalSharePrice,'type' : 'currency','decimalPosition': '2'}
                }
            }
        }
    }

    getDefaultHiddenState(parent: AddMultipleSecuritiesDialogComponent, fieldName: string, defaultState: boolean) {
        let s: any = JSON.parse(window.localStorage.getItem(parent.componentName) || "{}");

        if(s.COL_STATE) {
            let c: any  = JSON.parse(s.COL_STATE);

            if(c) {
                let d = c.find((x: any) => x.colId == fieldName);
                return d?.hide;
            }
        }

        return defaultState;
    }
}
